import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Text, Modal } from '@bufferapp/ui';
import translations from '~/i18n/translations/en-us.json';

const ModalBody = styled(Text)`
  padding: 16px 16px 0 16px;
  margin: 0;
`;

type PropTypes = {
  onConfirmDismissComposer: () => void;
  onCancelDismissModal: () => void;
};

const CloseStoryComposerConfirmationModal = ({
  onConfirmDismissComposer,
  onCancelDismissModal,
}: PropTypes): ReactElement => {
  const modalTranslations = translations['close-composer-confirmation-modal'];

  return (
    <Modal
      action={{
        label: modalTranslations.sure,
        callback: onConfirmDismissComposer,
      }}
      closeButton={{
        callback: onCancelDismissModal,
      }}
      secondaryAction={{
        label: modalTranslations.cancel,
        callback: onCancelDismissModal,
      }}
    >
      <ModalBody type="p">{modalTranslations.text}</ModalBody>
    </Modal>
  );
};

export { CloseStoryComposerConfirmationModal };
